import { Checkbox } from "@website/ui/checkbox";
import { MiniChips } from "@website/ui/mini-chips";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { FilterCollapse } from "@website/widget/filter/collapse";
import { CheckboxTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { Fragment } from "react";
interface CheckboxFilterProperties extends CheckboxTypes {
  name: string;
  collapseClassName?: string;
  containerClassName?: string;
}
export const CheckboxFilter = (properties: CheckboxFilterProperties) => {
  const {
    name,
    title,
    collapsible,
    options = [],
    isNew = false,
    showTitle = true,
    collapseClassName,
    containerClassName,
    onChange
  } = properties;
  const router = useRouter();
  const {
    [name]: value
  } = router.query as Record<string, string>;
  const valueArray = toString(value).split(",").filter(Boolean);
  function isChecked(option: string) {
    return valueArray.includes(option);
  }
  function _onChange(label: string, option_0: string) {
    return function ({
      target: {
        checked
      }
    }: {
      target: {
        checked: boolean;
      };
    }) {
      router.replace({
        query: deepOmit({
          ...router.query,
          ...(checked ? {
            [name]: [...valueArray, option_0].join(",")
          } : {
            [name]: valueArray.filter(op => op !== option_0)
          })
        }, isFilled)
      }, undefined, {
        shallow: true,
        scroll: false
      });
      onChange?.({
        name: option_0,
        label,
        isChecked: checked
      });
    };
  }
  return <Fragment>
      <div className="inline-grid grid-cols-2 items-center gap-2">
        {showTitle && <span className={styles["filter-header"]}>{title}</span>}
        {isNew && <MiniChips color="primary" text="جدید" variant="round-contained" />}
      </div>
      <FilterCollapse active={collapsible} className={collapseClassName} containerClassName={containerClassName}>
        {options.map(option_1 => <div className={styles["filter-checkbox-container"]} key={name + option_1.name}>
            <Checkbox checked={isChecked(option_1.name)} className={styles["filter-checkbox"]} color="secondary" label={option_1.label} onChange={_onChange(option_1.label, option_1.name)} name={option_1.name} />
            {option_1.icon}
          </div>)}
      </FilterCollapse>
    </Fragment>;
};